<template>
  <div v-if="consignment">
    <a-card>
      <a-row :gutter="16">
        <a-col class="gutter-row" :span="12">
            <h4>Consignment</h4>
            <div class="row mb-1">
              <div class="col-3"> <strong>Consignment ID:</strong></div>
              <div class="col-9">{{consignment.unique_id}}</div>
            </div>
            <div class="row mb-1">
              <div class="col-3"> <strong>Tolat task:</strong> </div>
              <div class="col-9">{{consignment.tasks.length}}</div>
            </div>
            <div class="row mb-1">
              <div class="col-3"><strong>Fully Delivered:</strong></div>
              <div class="col-9">{{getDelivered(consignment.tasks)}}</div>
            </div>
            <!-- <div class="row mb-1">
              <div class="col-3"><strong>Partially Delivered:</strong> </div>
              <div class="col-9">{{getPartialDelivered(consignment.tasks)}}</div>
            </div> -->
            <div class="row mb-1">
              <div class="col-3"><strong>Fail Delivered:</strong> </div>
              <div class="col-9">{{getFailedDelivered(consignment.tasks)}}</div>
            </div>
            <div class="row mb-1">
              <div class="col-3"><strong>Total Collectable: </strong> </div>
              <div class="col-9">{{calTotalCollectable(consignment)}}</div>
            </div>
            <div class="row mb-1">
              <div class="col-3"><strong>Total Collected: </strong> </div>
              <div class="col-9"><strong style="font-weight: bolder">{{totalcalTotalCollected(consignment)}}</strong></div>
            </div>
        </a-col>
        <a-col v-if="consignment.rider" class="gutter-row" :span="12">
            <h4>Rider</h4>
            <div class="row mb-1">
              <div class="col-2"><strong>Name:</strong></div>
              <div class="col-9">
                <img v-if="consignment.rider.image_path" :src="consignment.rider.image_path" height="25" />
                <img v-else  src="../../../assets/imgs/people/User_icon.png" height="25" />
                {{consignment.rider.name}}</div>
            </div>
            <div class="row mb-1">
              <div class="col-2"><strong>Mobile:</strong> </div>
              <div class="col-9">{{consignment.rider.mobile}}</div>
            </div>
            <div class="row mb-1">
              <div class="col-2"><strong>Email:</strong></div>
              <div class="col-9">{{consignment.rider.email}}</div>
            </div>
            <div class="row mb-1">
              <div class="col-2"><strong> Hub:</strong> </div>
              <div class="col-9">{{consignment.rider.hub.name}}</div>
            </div>
        </a-col>
      </a-row>
      
      <div class="text-right">
        <a-button type="danger" icon="poweroff" :loading="loading" size="large" @click="reconciliationComplete">
          Reconciliation Complete 
        </a-button>
      </div>
    </a-card>

    <a-card>
      <a-table :columns="columns" :data-source="consignment.tasks" :pagination="false" rowKey="id">
        
        <div slot="task_info" slot-scope="text, record">
          <p>Order Id: <strong>{{record.order.unique_id}}</strong></p>
          <p>Zone: {{ record.order.zone && record.order.zone.name ? record.order.zone.name : ''}}</p>
          <p>Picking Date: {{record.order.picking_date}}</p>
          <a-tag color="orange"> {{record.order.order_status.name}} </a-tag>
        </div>

        <div slot="customer_info" slot-scope="text, record">
          <h5>{{record.order.customer.name}}</h5>
          <p>{{record.order.customer.mobile}}</p>
          <p>{{record.order.customer.email}}</p>
          <p>{{record.order.hub.name}}</p>
          <p>{{record.order.customer_address}}</p>
        </div>

        <div slot="products" slot-scope="text, record">
          <span v-for="(product, index) in record.order.details" :key="index">
            {{product.product_name}}, 
          </span>
        </div>

        <span slot="action" slot-scope="text, record">
          <div>
            <div>
              <div class="d-flex">
                <div class="mt-3 mr-2">Rider Selected: </div>
                <div>
                  <a-select show-search
                    :filter-option="filterOption"
                    style="width: 200px" :default-value="record.status ? record.status : 3"
                    placeholder="Select Order status" class="mt-2" @change="(value) => selectOrderStatus(record, value)">
                    <a-select-option v-for="status in orderStatus2" 
                      :key="status.id" 
                      :value="status.id" 
                      style="width: 100%"
                      :disabled="checkDisabled(status)">
                      {{status.name}}
                    </a-select-option>
                  </a-select>
                </div>
              </div>
            </div>

            <div :id="'js-task-'+record.id" :class="!(record.status === 6 || record.status === 7) ? 'hide' : ''">
              
              <div class="reason-content">
                <a-select show-search
                  :filter-option="filterOption"
                  style="width: 200px" placeholder="Select Reason"
                  :dropdownStyle="{'width': '100%'}" :dropdownMatchSelectWidth="false"
                  :default-value="record.reason && record.reason.id ? record.reason.id : undefined"
                  class="mt-2"  @change="(value) => selectReasonSelect(record, value)">
                  <a-select-option v-for="reason in reasons" :key="reason.id" :value="reason.id" style="width: 100%">
                    {{reason.title}}
                  </a-select-option>
                </a-select>
              </div>

              <div>
                <a-select show-search
                  :filter-option="filterOption" 
                  class="mt-2" style="width: 200px" 
                  placeholder="Select Action" 
                  :default-value="record.order.order_status.id && (record.order.order_status.id === 9 || record.order.order_status.id === 10 ) 
                    ? record.order.order_status.id : undefined" 
                  @change="(value) => selectAction(record, value)">
                    <a-select-option :value="9">
                      Reassign
                    </a-select-option>
                    <a-select-option :value="10">
                      Return
                    </a-select-option>
                  </a-select>
              </div>

              <div :id="'js-reassign-date-'+record.id" 
                :class="!(record.order.order_status.id && record.order.order_status.id === 9 ) ? 'hide' : ''">
                
                <!-- :default-value="selectReassinedDate(record)" -->
                <a-date-picker class="mt-2" style="width: 200px" 
                  :disabled-date="disabledDate" 
                  @change="(date, dateString) => reassignDateSelecet(record, dateString)" />
              </div>
              
              <div>
                <a-button @click="showRemarkModal(record)" type="primary" class="mt-2 btn-remark" size="small"> Remark </a-button>
              </div>
            </div>

          </div>
        </span>
      </a-table>
    </a-card>
    <a-modal
        title="Remark"
        :visible="visibleRemark"
        :footer="null"
        @cancel="() => {this.visibleRemark = false; this.form.resetFields()}"
        >
        <a-form layout='vertical' :form="form" @submit="addremark">
            <a-form-item>
              <a-textarea :default-value="selecterTask && selecterTask.note ? selecterTask.note : undefined"
                v-decorator="[
                  'remark',
                  {
                      rules: [{ required: true, message: 'Please input Note' }],
                  }
                ]"
                placeholder="Enter note"
                :auto-size="{ minRows: 3, maxRows: 5 }"
              />
            </a-form-item>
            <a-form-item>
                <a-button @click="() => this.visibleRemark = false" size="large">
                    Cancel
                </a-button>
                <a-button type="primary" size="large" class="float-right btn btn-xs" html-type="submit">
                    Submit
                </a-button>
            </a-form-item>
        </a-form>
    </a-modal>
  </div>
</template>

<script>
import moment from 'moment';
// 
import { CONSIGNMENT_LIST, ALL_REASON, ORDER_STATUS_LIST, RECONSIGMENT_CREATE} from "../../../script/api"; //
// 
import { getData,  postData} from "../../../script/api-service"; //
import {alertPop} from "../../../script/helper";
import { totalCollectable, totalCollected } from './helper';

const columns = [
    {
      title: 'Task Info',
      width: 230,
      scopedSlots: { customRender: 'task_info' },
    },
    {
      title: 'Customer',
      width: 200,
      scopedSlots: { customRender: 'customer_info' },
    },
    {
      title: 'Product',
      scopedSlots: { customRender: 'products' },
    },
    {
      title: 'Total Amount',
      dataIndex: 'order.total_collectable_amount',
    },
    {
      title: 'Action',
      key: 'action',
      scopedSlots: { customRender: 'action' },
    },
];

export default {
  props: ['consignmentId'],
  data() {
    return {
      form: this.$form.createForm(this, { remard: '' }),
      visibleRemark: false,
      columns,
      consignment: null,
      reasons: [],
      orderStatus: [],
      disabledDate(current) {
        return current && current < moment().endOf('day');
      },
      selecterTask: null,
      loading: false,
      orderStatus2: [
        // { id: 1, name: "Assigned" },
        // { id: 2, name: "BeingPicked" },
        // { id: 3, name: "Picked" },
        // { id: 4, name: "InTransit" },
        { id: 5, name: "Delivered" },
        // { id: 6, name: "Partial" },
        { id: 7, name: "Failed" },
      ]
    };
  },
  methods: {
    calTotalCollectable(order) {
        return totalCollectable(order.tasks);
    },
    totalcalTotalCollected(order) {
        return totalCollected(order.tasks);
    },
    showRemarkModal(task) {
      this.visibleRemark = true;
      this.selecterTask = task; 
    },
    async getConsignmentData() {
        let url = CONSIGNMENT_LIST + `?id=${this.consignmentId}&paginate=false`;
        let res = await getData(url);

        if (res) {
            let masterData = res.data?.data;
            this.consignment = masterData;

          if (this.consignment.status !== 2) {
            this.$router.push({ path: '/manage-consignment' });
          }
        }
    },
    async getReasongs() {
        let res = await getData(ALL_REASON);

        if (res) {
            let masterData = res.data?.data.reasons;
            this.reasons = masterData;
        }
    },
    async getOrderStatus() {
        let res = await getData(ORDER_STATUS_LIST);

        if (res) {
            let masterData = res.data?.data;
            this.orderStatus = masterData;
        }
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      );
    },
    selectReassinedDate(task) {
      let find = this.consignment.tasks.find(e => e.id === task.id);
      if (find && !find.changed) return moment(task.order.delivery_date , 'YYYY-MM-DD');
      else return undefined;
    },
    getFailedDelivered(taskes) {
      let total = taskes.filter(t => t.order.order_status.name === 'Failed')

      return total.length || 0;
    },
    getDelivered(taskes) {
      let total = taskes.filter(t => t.order.order_status.name === 'Delivered')

      return total.length || 0;
    },
    getPartialDelivered(taskes) {
      let total = taskes.filter(t => t.order.order_status.name === 'Partial')

      return total.length || 0;
    },
    checkDisabled(status) {
      let activeOrder = "Delivered, Failed";
      return !activeOrder.includes(status.name);
    },
    selectOrderStatus(order, value) {
      let selectedOrderStatus = this.orderStatus2.find(e => e.id === value);
      let index = this.consignment.tasks.findIndex(e => e.id === order.id);
      
      if (index !== -1) {
        this.consignment.tasks[index].selectedOrderStatus = selectedOrderStatus;
        this.consignment.tasks[index].changed = true;

        console.log("selectedOrderStatus", selectedOrderStatus);

        let element = document.getElementById(`js-task-${order.id}`);
        if (selectedOrderStatus.name === "Failed" || selectedOrderStatus.name === "Partial") {
            element.classList.remove("hide");
        } else {
            element.classList.add("hide");
        }
      }
    },
    selectAction(task, value) {
      let index = this.consignment.tasks.findIndex(e => e.id === task.id);
      
      if (index !== -1) {
        this.consignment.tasks[index].selected_order_status = value * 1;
        this.consignment.tasks[index].changed = true;
        let element = document.getElementById(`js-reassign-date-${task.id}`);
        if (value == 9) {
            element.classList.remove("hide");
        } else {
            element.classList.add("hide");
        }
      }
    },
    reassignDateSelecet(task, value) {
      let index = this.consignment.tasks.findIndex(e => e.id === task.id);
      
      if (index !== -1) {
        this.consignment.tasks[index].selectedReassignDate = value;
        this.consignment.tasks[index].changed = true;
      }
    },
    selectReasonSelect(task, value) {
      let index = this.consignment.tasks.findIndex(e => e.id === task.id);
      
      if (index !== -1) {
        this.consignment.tasks[index].selectedReason = value;
        this.consignment.tasks[index].changed = true;
      }
    },
    addremark(e) {
      e.preventDefault();
      this.form.validateFields(async (err, values) => {
        if (!err) {
          let index = this.consignment.tasks.findIndex(e => e.id === this.selecterTask.id);
        
          if (index !== -1) {
            this.consignment.tasks[index].remark = values.remark;
            this.consignment.tasks[index].changed = true;

            this.selecterTask = null;
            this.form.resetFields();
            this.visibleRemark = false;
          }
        }
      })
    },
    async reconciliationComplete() {
      let reData = {
        consignment_id: this.consignment.id
      },
      tasks= [],
      notDelevard= 0;

      if (this.consignment.tasks && this.consignment.tasks.length) {
        this.consignment.tasks.forEach(task => {
          if (task.changed || (task?.order?.order_status?.name === "Delivered" || task?.order?.order_status?.name === "Customer Order Confirmed")) {
            let data = {};

            data.task_id = task.id;
            data.task_status = task?.selectedOrderStatus?.id || task.status;

            if (task?.selectedOrderStatus?.name === 'Failed' || task?.selectedOrderStatus?.name === "Partial" || task.status === 6 ||  task.status === 7) {
              data.order_status = task?.selected_order_status ? task?.selected_order_status : task.order.order_status.id ? task.order.order_status.id : '';
              
              if (task.selected_order_status == 9 || task.order?.order_status?.id === 9) data.date = task.selectedReassignDate || task.delivery_date;
              data.reason_id = task.selectedReason ? task.selectedReason : task?.reason?.id ? task?.reason?.id : '';
              data.note = task.remark || task.note;
            }

            let payload = [];

            if (task.payload && task.payload.length ) {
              task.payload.forEach(product => {
                let data = {
                  "product_name": product.product_name,
                  "product_category_id": product.product_category_id,
                  "product_quantity": product.product_quantity,
                  "product_price": product.product_price,
                  product_id: product.product_id
                }

                payload.push(data);
              })
            }

            data.payload = payload;

            tasks.push(data);
            
            if(data.task_status !== 5) notDelevard = notDelevard + 1;
          }
        });

        reData.data = tasks;
      }

      if (reData.data && reData.data.length === this.consignment.tasks.length ) {
        let reDataNotDelevard = reData.data.filter(re => re.task_status !== 5);

        if (reDataNotDelevard.length !== notDelevard && this.consignment.tasks.length !== reData.data.length) {
          alertPop('error', "Please first update all partial and failed taskes");
          return false
        }

        this.loading = true;
        let res = await postData(RECONSIGMENT_CREATE, reData);

        if (res) {
          alertPop('success', "Reconciliation Completed Successfully");
          this.loading = false;
          this.$router.push({ path: '/manage-consignment' });
        } else {
          this.loading = false;
          
        }
      } else {
          alertPop('error', "First Update tasks!");
          this.loading = false;
      }
    }
  },
  mounted() {
      this.getConsignmentData();
      this.getReasongs();
      this.getOrderStatus();
  },
}
</script>

<style scoped>
  .btn-remark {
    background-color: #faa414;
    color: #ffffff;
    border: none;
    font-size: 14px;
    font-weight: 400;
    border-radius: 4px;
    display: inline-block;
    padding: 0px 19px;
  }
</style>